(function() {
  function openSizeGuidePopup(variantId) {
    var existing = document.getElementById('sg-overlay');
    if (existing) existing.remove();

    var overlay = document.createElement('div');
    overlay.id = 'sg-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.7);z-index:999999;display:flex;align-items:flex-end;justify-content:center;padding-bottom:80px;';

    var modal = document.createElement('div');
    modal.style.cssText = 'background:#fff;width:100%;max-height:60vh;border-radius:16px 16px 0 0;overflow:hidden;display:flex;flex-direction:column;';
    modal.innerHTML = ''
      + '<div style="background:#121212;padding:16px 20px;display:flex;justify-content:space-between;align-items:center;flex-shrink:0;">'
      + '<span style="color:#fce477;font-weight:700;font-size:16px;">📏 Guide des tailles</span>'
      + '<button onclick="document.getElementById(\'sg-overlay\').remove()" style="background:none;border:none;color:#fff;font-size:24px;cursor:pointer;line-height:1;">✕</button>'
      + '</div>'
      + '<div style="overflow-y:auto;flex:1;padding:24px 20px;">'
      + '<p style="font-size:14px;color:#555;margin-bottom:20px;">Consultez notre guide des tailles avant de commander pour éviter les retours.</p>'
      + '<a href="/pages/mesurez-votre-taille" target="_blank" style="display:block;text-align:center;background:#121212;color:#fce477;padding:14px;border-radius:8px;font-weight:700;font-size:15px;text-decoration:none;margin-bottom:16px;">📏 Ouvrir le guide des tailles →</a>'
      + '</div>'
      + '<div style="padding:16px;background:#fff;border-top:1px solid #eee;flex-shrink:0;">'
      + '<button id="sg-checkout-btn" style="width:100%;background:#fce477;color:#121212;border:none;padding:16px;font-size:16px;font-weight:700;border-radius:8px;cursor:pointer;">J\'ai vérifié ma taille — Commander →</button>'
      + '</div>';

    overlay.appendChild(modal);
    overlay.addEventListener('click', function(e){ if(e.target===overlay) overlay.remove(); });
    document.body.appendChild(overlay);

    document.getElementById('sg-checkout-btn').addEventListener('click', function() {
      if (variantId) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({id: variantId, quantity: 1})
        }).then(function() {
          window.location.href = '/checkout';
        });
      } else {
        window.location.href = '/checkout';
      }
    });
  }

  function getVariantId() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var input = form ? form.querySelector('[name="id"]') : null;
    return input ? input.value : null;
  }

  function attachBtn(btn) {
    if (btn.dataset.sgDone) return;
    btn.dataset.sgDone = 'true';
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openSizeGuidePopup(getVariantId());
    }, true);
  }

  function findAndAttach() {
    var btn = document.getElementById('bundle-sticky_submit');
    if (btn) { attachBtn(btn); return; }
    document.querySelectorAll('.Vtl-StickyAddToCart__AddToCartButton').forEach(attachBtn);
  }

  var observer = new MutationObserver(findAndAttach);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  var attempts = 0;
  var interval = setInterval(function() {
    findAndAttach();
    if (++attempts >= 20) clearInterval(interval);
  }, 500);
})();

